var _style, _path, _g, _polyline, _path2, _path3, _path4, _polygon, _path5, _path6, _rect, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAerobicStrengthCircuit({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 212.6 212.6",
    style: {
      enableBackground: "new 0 0 212.6 212.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#F4A38A;}\n\t.st1{fill:#E6393D;}\n\t.st2{fill:none;stroke:#F8EEE1;stroke-width:4.6669;stroke-miterlimit:10;}\n\t.st3{fill:none;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M106.3,182.9c42.69,0,77.3-34.29,77.3-76.6c0-42.3-34.61-76.6-77.3-76.6S29,63.99,29,106.3 C29,148.6,63.61,182.9,106.3,182.9"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M151.62,92.54c-0.14-13.61-10.34-24.52-22.79-24.39c-12.44,0.13-22.41,11.26-22.27,24.87 c-0.14-13.61-10.35-24.52-22.8-24.39c-12.44,0.13-22.41,11.26-22.27,24.87c0.04,4.17,1.17,8.35,2.98,12.46 c0,0.08-0.02,0.16-0.01,0.24c0.03,0.51,0.1,0.98,0.2,1.43c0,0-0.01,0-0.01,0c0.01,0.03,0.02,0.05,0.04,0.08 c0.33,1.4,0.99,2.49,1.87,3.34l-0.9-0.02c11.24,21.87,41.52,40.78,41.52,40.78s29.79-19.51,40.6-41.59l-0.97,0.05 c0.82-0.98,1.36-2.23,1.48-3.87c0-0.07-0.01-0.12-0.01-0.19l0.16,0C150.48,101.71,151.67,97.1,151.62,92.54z"
  })))), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "st2",
    points: "60.08,109.22 87.23,108.74 91.36,97.67 102.59,127.7 110.27,103.12 114.69,115.41 122.75,102.05  125.75,113.31 127.56,109.03 150.81,109.36 "
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M117.52,91.49c0-0.04,0-0.08-0.01-0.11C117.52,91.41,117.52,91.45,117.52,91.49L117.52,91.49z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M117.34,89.91L117.34,89.91c0.01,0.08,0.02,0.17,0.04,0.25C117.36,90.08,117.35,90,117.34,89.91z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M116.83,87.87c-0.02-0.07-0.05-0.13-0.07-0.2C116.78,87.74,116.81,87.81,116.83,87.87L116.83,87.87z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "115.55,99.97 115.55,99.97 115.54,99.97 "
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M117.41,94.56c0,0.02-0.01,0.04-0.01,0.07C117.4,94.6,117.4,94.58,117.41,94.56z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M114.09,102.05L114.09,102.05c-0.27,0.32-0.55,0.65-0.86,0.95C113.54,102.69,113.82,102.37,114.09,102.05z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 114.82,
    y: 101.1,
    className: "st3",
    width: 0,
    height: 0
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M117.11,96.09c-0.01,0.02-0.01,0.04-0.02,0.07C117.1,96.13,117.11,96.11,117.11,96.09z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M117.54,93.03c0,0.01,0,0.02,0,0.03C117.54,93.05,117.54,93.04,117.54,93.03z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAerobicStrengthCircuit);
export default __webpack_public_path__ + "static/media/Aerobic_strength_circuit.a78b03263f47ae59bcac9052e07f157e.svg";
export { ForwardRef as ReactComponent };